import { ErrorBoundary } from '@sentry/react'

const ErrorBoundaryViewReportArtifact = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    Whoops, we didn't expect this. Try refreshing this page!
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default ErrorBoundaryViewReportArtifact
